import React from 'react';
import { Icon, IconProps } from './Icon';

export const CircleArrowDown: React.FC<IconProps> = (props) => {
  return (
    <Icon
      strokeWidth={0.5}
      viewBox="0 0 20 21"
      width="20"
      height="21"
      {...props}
    >
      <path
        d="M10 2.375C14.4858 2.375 18.125 6.0142 18.125 10.5C18.125 14.9858 14.4858 18.625 10 18.625C5.5142 18.625 1.875 14.9858 1.875 10.5C1.875 6.0142 5.5142 2.375 10 2.375ZM10 3.625C6.20455 3.625 3.125 6.70455 3.125 10.5C3.125 14.2954 6.20455 17.375 10 17.375C13.7954 17.375 16.875 14.2954 16.875 10.5C16.875 6.70455 13.7954 3.625 10 3.625ZM10 6.51562C10.3409 6.51562 10.6182 6.78861 10.625 7.12793V12.3584L12.6846 10.3154C12.9295 10.0724 13.3252 10.0735 13.5684 10.3184C13.8081 10.56 13.8101 10.9485 13.5752 11.1924L13.5654 11.2021L10.4404 14.3027C10.2003 14.541 9.81466 14.5449 9.57031 14.3135L9.55957 14.3027L6.43457 11.2021C6.18972 10.959 6.18857 10.5633 6.43164 10.3184C6.67131 10.077 7.05904 10.072 7.30469 10.3047L7.31543 10.3154L9.375 12.3584V7.14062C9.375 6.79545 9.65482 6.51562 10 6.51562Z"
        fill="#0058A8"
      />
    </Icon>
  );
};
